<template>
  <div v-if="visible" class="system-mode-banner" :class="bannerClass" role="status">
    {{ display }}
  </div>
</template>

<script setup lang="ts">
import { useSystemMode } from '../composables/useSystemMode'

const { display, visible, bannerClass } = useSystemMode()
</script>

<style lang="scss">
.system-mode-banner {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  z-index: 10000;
  height: var(--system-mode-banner-height, 2rem);
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 0 1rem;
  color: #fff;
  font-size: 0.8125rem;
  font-weight: 700;
  letter-spacing: 0.04em;
  text-align: center;
  line-height: 1.2;
}

.system-mode-banner--dev {
  background: #ea580c;
}

.system-mode-banner--qa {
  background: #7c3aed;
}

.system-mode-banner--default {
  background: #475569;
}

body.has-system-mode-banner {
  --system-mode-banner-height: 2rem;
  padding-top: var(--system-mode-banner-height);
}

body.has-system-mode-banner .va-layout-fixed-wrapper__content--top {
  top: var(--system-mode-banner-height) !important;
}
</style>
